let result;
result = {
  selfContact: {
    firstName: 'Self',
    lastName: 'Reference',
    userId: 'ffffffffffffffffffffffff',
  },
  groupChatCountiesModeratorId: 'med-87753212395afe52ebefa8827c6f7bf2',
  calls: {
    // around (=before and after) the scheduledAt date
    revealTokenMillis: 1000 * 60 * 90,
  },
  contactPage: {
    personalNote: {
      maxChars: 3000,
      title: 'Liebe Patient:innen,',
      text: 'mit medflex bieten wir Ihnen einen direkten, sicheren und zertifizierten Kommunikationskanal zwischen Ihnen und uns. Ganz einfach und ohne Kosten für Sie.',
      getText() {
        return `${this.title}\n${this.text}`;
      },
    },
  },
  areaOfActivity: {
    OTHER: 'Andere Heilberufe',
    PRACTICE: 'Arzt (Praxis)',
    CLINIC: 'Arzt (Klinik)',
    DENTIST: 'Zahnarzt',
    PSYCHIATRIST: 'Psychiatrie / Psychotherapie',
    OCCUPATIONAL_THERAPIST: 'Ergotherapie',
    SPEECH_THERAPIST: 'Logopädie',
    PHYSIOTHERAPIST: 'Physiotherapie',
    GERIATRIC_NURSE: 'Altenpflege',
    NURSING_SERVICE: 'Pflegedienst / Pflegepersonal',
    MIDWIFE: 'Geburtshilfe',
    NUTRITIONIST: 'Ernährungsberatung',
    MEDICAL_LAB: 'Medizinisches Labor',
    PHARMACY: 'Apotheke',
    ASSISTENT: 'MFA / Praxisassistenz',
    CUSTOM: 'Sonstige Tätigkeit',
  },
  userActivities: {
    loggedInAtDays: 'loggedInAtDays',
    readMessagesAtDays: 'readMessagesAtDays',
    sentTextMessagesAtDays: 'sentTextMessagesAtDays',
    sentFileMessagesAtDays: 'sentFileMessagesAtDays',
    sentPatientMessagesAtDays: 'sentPatientMessagesAtDays',
    createdCallsAtDays: 'createdCallsAtDays',
    passiveCallsAtDays: 'passiveCallsAtDays',
    joinedCallsAtDays: 'joinedCallsAtDays',
    createdChatsAtDays: 'createdChatsAtDays',
  },
  dentistWorkAreas: [
    ['Kieferorthopädie'],
    ['Mund-Kiefer-Gesichtschirurgie'],
    ['Zahnmedizin'],
    ['Anderes Fachgebiet'],
  ],
  psychiatristWorkAreas: [
    ['Psychiatrie und Psychotherapie'],
    ['Forensische Psychiatrie'],
    ['Psychologische Psychotherapie'],
    ['Kinder- und Jugendlichenpsychotherapie'],
    ['Psychosomatische Medizin und Psychotherapie'],
    ['Anderes Fachgebiet'],
  ],
  workAreaValues: [
    ['Allergologie'],
    ['Allgemeinmedizin'],
    ['Anästhesiologie'],
    ['Anatomie'],
    ['Arbeitsmedizin'],
    ['Augenheilkunde'],
    ['Biochemie'],
    [
      'Chirurgie',
      [
        'Gefäßchirurgie',
        'Herzchirurgie',
        'Kinderchirurgie',
        'Orthopädie und Unfallchirurgie',
        'Plastische und Ästhetische Chirurgie',
        'Thoraxchirurgie',
        'Viszeralchirurgie',
      ],
    ],
    [
      'Frauenheilkunde und Geburtshilfe',
      [
        'Gynäkologische Endokrinologie und Reproduktionsmedizin',
        'Gynäkologische Onkologie',
        'Spezielle Geburtshilfe und Perinatalmedizin',
      ],
    ],
    [
      'Hals-Nasen-Ohrenheilkunde',
      ['Sprach-, Stimm- und kindliche Hörstörungen'],
    ],
    ['Haut- und Geschlechtskrankheiten'],
    ['Humangenetik'],
    ['Hygiene und Umweltmedizin'],
    [
      'Innere Medizin',
      [
        'Angiologie',
        'Diabetologie',
        'Endokrinologie und Diabetologie',
        'Gastroenterologie',
        'Geriatrie',
        'Hämatologie',
        'Immunologie',
        'Infektiologie',
        'Kardiologie',
        'Nephrologie',
        'Onkologie',
        'Pneumologie',
        'Rheumatologie',
      ],
    ],
    ['Intensivmedizin'],
    ['Kieferorthopädie'],
    [
      'Kinder- und Jugendmedizin',
      [
        'Kinder-Hämatologie und -Onkologie',
        'Kinder-Kardiologie',
        'Kinderpneumonologie',
        'Neonatologie',
        'Neuropädiatrie',
      ],
    ],
    ['Kinder- und Jugendpsychiatrie und -psychotherapie'],
    ['Komplementärmedizin'],
    ['Laboratoriumsmedizin'],
    ['Mikrobiologie, Virologie und Infektionsepidemiologie'],
    ['Mund-Kiefer-Gesichtschirurgie'],
    ['Neurochirurgie'],
    ['Neurologie'],
    ['Neurologie und Psychiatrie'],
    ['Notfallmedizin'],
    ['Nuklearmedizin'],
    ['Öffentliches Gesundheitswesen'],
    ['Palliativmedizin'],
    ['Pathologie', ['Neuropathologie']],
    [
      'Pharmakologie',
      ['Klinische Pharmakologie', 'Pharmakologie und Toxikologie'],
    ],
    ['Physikalische und Rehabilitative Medizin'],
    ['Physiologie'],
    ['Psychiatrie und Psychotherapie', ['Forensische Psychiatrie']],
    [
      'Psychologische Psychotherapie',
      ['Kinder- und Jugendlichenpsychotherapie'],
    ],
    ['Psychosomatische Medizin und Psychotherapie'],
    ['Radiologie', ['Kinderradiologie', 'Neuroradiologie']],
    ['Rechtsmedizin'],
    ['Schlafmedizin'],
    ['Schmerzmedizin'],
    ['Strahlentherapie'],
    ['Transfusionsmedizin'],
    ['Urologie'],
    ['Versicherungswesen'],
    ['Zahnmedizin'],
    ['Anderes Fachgebiet'],
  ],

  organizationalForm: {
    SINGLE_PRACTICE: 'Einzelpraxis',
    GROUP_PRACTICE: 'Gemeinschaftspraxis',
    MVZ: 'MVZ',
    CLINIC_HOSPITAL: 'Klinik / Krankenhaus',
    MEDICAL_CENTER: 'Medizinisches Institut',
  },

  usedFeatures: {
    VIDEO_CHAT: 'Videosprechstunde / Videokonsile',
    FILE_UPLOAD: 'Datei- & Dokumentenübermittlung',
    PATIENT_CHAT: 'Patienten Kommunikation',
    PHYSICIAN_CHAT: 'Kollegen Austausch',
    TEAM_MESSENGER: 'Kommunikation in Ihrem Team',
  },

  snippets: {
    maxSnippets: 50,
    maxText: 4000,
    maxTitle: 200,
  },

  greetingMessage: {
    maxText: 3000,
    defaultGreeting: 'Guten Tag {{firstName}} {{lastName}},',
    defaultText:
      'vielen Dank für Ihre Registrierung. Wir können Ihnen ab sofort über diesen Weg sicher Nachrichten und Dateien senden oder Ihre Anfragen beantworten.',
  },

  demoPatient: {
    idPrefix: 'pat-demo-',
  },
};

result.areaOfActivityIds = Object.keys(result.areaOfActivity);
result.userActivityNames = Object.values(result.userActivities);

module.exports = result;
